
import router from '@/router'
import {useStore} from "vuex"
import {ref, reactive} from 'vue'
import{ useMutations} from '@/store/helper'
export default {
name:"Initial",
emits:["onFire"],
  components:{
  },
  setup(props:any,{emit}:any) {
     const store= useStore();
     const formRef = ref<HTMLFormElement>();
     const mostrarEnProceso = ref(false)
     const estadoTestSet = ref('')
     const mensajeBody = ref('Ingresar en el siguiente campo, el TestSetID que la DIAN generó como resultado del proceso de habilitación.')
     let ruleForm= reactive( {
      TestSetValue: ''});
    let rules= reactive( {
        TestSetValue: [
          { required: true, message: 'El código de habilitación no puede estar vacío', trigger: 'blur' },
          { min: 1, message: 'El código de habilitación no puede estar vacío', trigger: ['blur', 'change'] },
          { pattern: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, message: 'El código de habilitación no es válido. Por favor verifica que no contenga espacios en blanco o caracteres especiales diferentes al guion', trigger: 'blur' }
        ],})
     const{setTestSet} = useMutations(['setTestSet']);
     function EviarTestset(){
        formRef.value?.validate((valid: boolean) => {
          if(valid){
            mostrarEnProceso.value = true;
            var data={
                Identificacion:localStorage.getItem('Identificacion'),
                Tipoidentificacion:localStorage.getItem('TipoIdentificacion'),
                TestSetDian:ruleForm.TestSetValue,
              }  
              setTestSet(data);
              store.dispatch('SendTestSet', localStorage.getItem('Tokensin')).then(data => {
                estadoTestSet.value = data.data;
                if(data.data === 'ErrorTestSet') {
                  mostrarEnProceso.value = false;
                  ruleForm.TestSetValue = '';
                  mensajeBody.value = 'Debes solicitar un nuevo TestSetId con el proveedor para continuar con la habilitación.';
                } else if(data.data === 'Rechazado') {
                  mostrarEnProceso.value = false;
                  ruleForm.TestSetValue = '';
                  mensajeBody.value = 'No podemos completar tu registro en este momento, Por favor, intenta de nuevo mas tarde.';
                } else {
                  emit("onFire", "EnProceso")
                }
              }).catch(error => {

              });
          }
        });
    };
    function goToDashboard(){
         router.push({name:'Dashboard'});
      }
  return{
    goToDashboard,
    EviarTestset,
    rules,
    ruleForm,
    formRef,
    mostrarEnProceso,
    mensajeBody,
    estadoTestSet
  };
}
  
};
